<template>
  <BaseTemplate :currentUser="currentUser" :isLineup="true" >
    <div class="pack-detail">
      <div v-if="currentPack" class="pack-banner-full">
        <img :src="currentPack.image" :alt="currentPack.name">
      </div>
      <div class="lineup-frame-title">
        <img src="/img/lineup_frame.png">
        <span>{{ t('ラインナップ') }}</span>
      </div>
      <div v-if="cardList" class="card_list_area">
        <div class="card_list">
          <CardList
            v-if="cardList && cardList.list"
            class="card-list return-point"
            :page="page"
            :cardListTitle="null"
            :isList="true"
            :isLineupMode="true"
            :packPoint="currentPack ? Number(currentPack.point) : 0"
            :cardList="cardList.list.map(card => ({
              id: card.id,
              action_type: card.action_type,
              image: card.image_url,
              name: card.name,
              card_type: card.card_type,
              shipping_schedule: card.shipping_schedule || '',
              title: card.title || '',
              rarity_label: card.rarity,
              buy_point: card.buy_point || 0,
              num: card.num || 1,
              model_number: card.model_number,
              duplication: card.duplication,
              is_digital_content: card.is_digital_content,
            }))"
            :isCoin="currentPackHistory && currentPackHistory.pack_name == '引換所の景品'"
            :shipping_type="'4'"
            @selectCard="handleDetailCard"
          />
        </div>
        <BoxPager
          v-if="
            cardList &&
            cardList.page.pages.length > 1
          "
          class="box-pager"
          :totalPageCount="cardList.page.all_page"
          :currentPageCount="cardList.page.page"
          :dispBoxCount="cardList.page.pages.length"
          :pages="cardList.page.pages"
          @handlePagerClick="changeCurrentPageCount"
          @handleSquareBtnClick="changeCurrentPageCount"
        />
      </div>
      <div v-if="currentPack" class="detail_area">
        <!-- 以下カードの下詳細部分左側 -->
        <div class="detail_left">
          <div class="count01">
            <span class="c01">
              <div class="image" >
                <img
                  src="/img/star_coin.webp?v=1"
                >
              </div>
              {{currentPack.point | comma}}<span v-if="currentPack.payment_method == '1'"></span>
              <span v-if="currentPack.payment_method == '2'">coins</span>
              <!-- / {{t('1回')}}</span> -->
            </span>
          </div>
          <div class="count02">
            <div class="">
              {{ t('残数') }} {{ currentPack.pack_count | comma }} /
              {{ currentPack.total_pack_count | comma }}
            </div>
          </div>
          <GachaBarGraph
              class="gacha-bar"
              :maxValue="Number(currentPack.total_pack_count)"
              :currentValue="Number(currentPack.pack_count)"
            />
        </div>
      <!-- 以下右側 -->
      <div class="detail_right">
          <div class="gray_area">
            <div class="point_base_area">
              <div class="count_base_area_block">
                <ErrorMessage
                  v-if="errorMessageCount"
                  class="error-message"
                  :message="errorMessageCount"
                />
                <div class="count_base_area">
                  <div class="area count_area">
                    <SelectBox
                      class="select_box"
                      :options="buyList"
                      selectedOption="1"
                      @handleSelectChange="changeCount" />
                    <BuyButton
                      :isShine="true"
                      :isArrow="false"
                      class="purchase-btn"
                      @handleSquareBtnClick="goToConfirmBuyProduct"
                    />
                  </div>
                <div class="limit_message" v-if="currentPack.can_limit === 1">
                  {{currentPack.limit_message}}
                </div>
              </div>
                <div class="limit_message" v-if="errorMessageCount">{{ t(errorMessageCount) }}</div>
                <div class="countdown" v-if="isCountdown">
                  <span class="label_title">{{t('販売開始まで')}}</span>
                  <span class="num">{{countdownStr}}</span>
                </div>
                <div v-if="currentPack.format_end_date" class="end_date">
                  <span>
                    <span class="end_date_day">{{ formattedSaleText }} </span>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 以下カードをクリックしたら表示されるポップアップ-->
      <div v-if="showCardDetail" class="popup_card_area" @click.self="showCardDetail = false">
        <div class="popup_card">
          <img class="popup-card-image" :src="popupCardData.image">
          <div class="popup-card-name">{{ popupCardData.name }}</div>
          <div v-if="popupCardData.rarity_label" class="popup-card-rarity">{{ popupCardData.rarity_label }}</div>
          <div v-if="popupCardData.model_number" class="popup-card-model">{{ popupCardData.model_number }}</div>
          <button class="popup-close-btn" @click="showCardDetail = false">{{ t('閉じる') }}</button>
        </div>
      </div>
    </div>
      <CommonOverlay class="overlay" v-show="isOpenPasswordModal" @handleOverlayClick="closePasswordModal">
      <CommonModal class="modal password-modal">
        <div>
          {{t('パスワード入力')}}
        </div>
        <TextBox class="text-box" v-model="inputPassword"/>
        <ErrorMessage
          v-if="passwordError"
          class="error-message"
          :message="passwordError"
        />
        <div class="modal-button-area">
          <BuyButton
            :isArrow="false"
            class="send-button"
            :text="t('送信')"
            @handleSquareBtnClick="submitPassword"
          />
          <SquareButton
            class="square-button"
            text="close"
            :isSub="true"
            @handleSquareBtnClick="closePasswordModal"
          />
        </div>
      </CommonModal>
    </CommonOverlay>
    <CommonOverlay class="overlay_conf" v-show="isOpenConfirm">
      <CommonModal class="modal pack-confirm">
        <GrayCloseButton
          class="close_button"
          @handleClick="closeModal"></GrayCloseButton>
        <div class="block">
          <div>{{ buyCoin | comma }}{{ t('コインを')}}</div>
          <div>{{ t('消費して') }}<br>{{ count | comma }}{{ t('回ガチャを引く') }}</div>
        </div>
        <div class="modal-button-area">
          <SimpleButton
            class="purchase-btn"
            :isArrow="false"
            @handleSquareBtnClick="buyPack"
          />
          <SimpleButton
            class="purchase-btn cancel-btn"
            :isArrow="false"
            :text="t('キャンセル')"
            @handleSquareBtnClick="closeModal"
          />
        </div>
      </CommonModal>
    </CommonOverlay>
  </BaseTemplate>
</template>

<script>
import { mapGetters } from 'vuex';
import {
  separateCharacterNumber,
  separateDecimalNumber,
} from '@/common/util/format';
import BaseTemplate from '@/components/templates/BaseTemplate.vue';
import SelectBox from '@/components/atoms/SelectBox.vue';
import BoxPager from '@/components/organisms/BoxPager.vue';
import t from '@/plugins/i18n';
import GachaBarGraph from '@/components/atoms/GachaBarGraph.vue';
import { shopLink } from '@/common/config/js/const';
import BuyButton from '@/components/atoms/BuyButton.vue';
import CardList from '@/components/organisms/CardList.vue';
import CommonOverlay from '@/components/atoms/CommonOverlay.vue';
import CommonModal from '@/components/atoms/CommonModal.vue';
import GrayCloseButton from '@/components/atoms/GrayCloseButton.vue';
import SimpleButton from '@/components/atoms/SimpleButton.vue';
import ErrorMessage from '@/components/atoms/ErrorMessage.vue';
import TextBox from '@/components/atoms/TextBox.vue';
import SquareButton from '@/components/atoms/SquareButton.vue';

export default {
  name: 'StorePackDetail',
  mixins: [t],

  components: {
    BaseTemplate,
    SelectBox,
    BoxPager,
    BuyButton,
    GrayCloseButton,
    SimpleButton,
    ErrorMessage,
    GachaBarGraph,
    CardList,
    CommonOverlay,
    CommonModal,
    TextBox,
    SquareButton,
  },

  data: () => ({
    isOpenModal: false,
    errorMessageCount: null,
    count: 1,
    showCardDetail: false,
    isOpenConfirm: false,
    popupCardData: {},
    isCountdown: false,
    countdownStr: '',
    page: 1,
    isOpenPasswordModal: false,
    inputPassword: '',
    passwordError: '',
  }),

  computed: {
    ...mapGetters({
      currentUser: 'user/currentUser',
      currentPack: 'pack/currentPack',
      currentPackCardList: 'pack/packCardList',
      packCheckResult: 'pack/packCheckResult',
      setCheckPackResult: 'pack/setCheckPackResult',
      buyPackResult: 'pack/buyPackResult',
      currentPackHistory: 'pack/currentPackHistory',
    }),
    packPoint() {
      if (this.currentPack) {
        return separateCharacterNumber(this.currentPack.point);
      }
      return 0;
    },
    cardList() {
      if (this.currentPackCardList) {
        return this.currentPackCardList;
      }
      return [];
    },
    isAvailable() {
      return parseInt(this.currentUser.point, 10) >= parseInt(this.currentPack.point, 10);
    },
    packCount() {
      if (this.currentPack) {
        return separateCharacterNumber(this.currentPack.pack_count);
      }
      return 0;
    },
    buyList() {
      if (!this.packCount) {
        return [];
      }
      const count = parseInt(this.packCount.replace(',', ''), 10);
      let max = count;
      if (max > 3000) {
        max = 3000;
      }
      const maxCount = parseInt(this.currentPack.max_buy_count, 10);
      if (maxCount > 0 && max > maxCount) {
        max = maxCount;
      }
      const option = [];
      for (let i = 1; i <= max; i += 1) {
        // option.push({ id: i, name: `${i}${this.t('パック')}` });
        option.push({ id: i, name: `${i}` });
      }
      return option;
    },
    formattedSaleText() {
      const dateText = this.currentPack.format_end_date;
      if (!dateText) return '';
      const date = new Date(dateText.replace(/-/g, '/'));
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const key = '{year}/{month}/{day} まで販売';
      const lang = this.currentUser?.language;
      const template = this.i18n_message?.[key]?.[lang] || key;
      return template
        .replace('{year}', year)
        .replace('{month}', month)
        .replace('{day}', day);
    },
    buyCoin() {
      if (this.currentPack) {
        return this.currentPack.point * this.count;
      }
      return 0;
    },
  },
  created() {
    const { errorMessageCount } = this.$route.query;
    this.errorMessageCount = errorMessageCount ? errorMessageCount[0] : null;
    this.$store.dispatch('pack/setCurrentPack', { packId: this.$route.query.packId });
    if (this.$route.query.packId) {
      this.$store.dispatch('pack/setPackCardList', { packId: this.$route.query.packId, pageNumber: 1 });
    }
  },

  filters: {
    comma(value) {
      return separateCharacterNumber(value);
    },
    commaFloat(value) {
      return separateDecimalNumber(value, true);
    },
  },

  watch: {
    packCheckResult(newVal) {
      if (newVal) {
        if (newVal.state === 200 && newVal.result === '1') {
          this.$store.dispatch('pack/clearPackCheckResult');
          this.isOpenConfirm = true;
        } else {
          const { count } = newVal.errors;
          this.errorMessageCount = count ? count[0] : null;
          this.isOpenModal = true;
        }
      }
    },
    currentPack(newVal) {
      if (newVal) {
        if (!newVal.id) {
          window.location.href = '/';
        }
        if (newVal.is_before) {
          this.isCountdown = true;
          this.setTimerID = setInterval(() => {
            this.setCountdownString();
          }, 1000);
          this.setCountdownString();
        }
      }
    },
  },

  methods: {
    setCountdownString() {
      const day1 = new Date(this.currentPack.start_date.replace(/-/g, '/'));
      const day2 = new Date();
      const diffDay = day1 - day2;
      if (diffDay < 0) {
        console.log('stop');
        this.isCountdown = false;
        console.log(this.isCountdown);
        clearInterval(this.setTimerID);
        return;
      }
      const h = `0${parseInt(diffDay / (1000 * 60 * 60), 10)}`.slice(-2);
      const m = `0${parseInt((diffDay % (1000 * 60 * 60)) / (1000 * 60), 10)}`.slice(-2);
      const s = `0${parseInt((diffDay % (1000 * 60)) / (1000), 10)}`.slice(-2);
      this.countdownStr = `${h}.${m}.${s}`;
    },
    changeCount(val) {
      this.count = parseInt(val, 10);
    },
    closeModal() {
      this.isOpenModal = false;
      this.isOpenConfirm = false;
    },
    goToBuyPoint() {
      // ポイント購入画面へ
      const query = { packId: this.$route.query.packId };
      this.$router.push({ path: '/buy-point', query });
    },
    goToConfirmBuyProduct() {
      if (this.currentUser.is_login === '0') {
        this.$router.push({ path: '/' });
        this.$store.dispatch('user/setShowLoginPage', true);
        return;
      }
      if (this.currentPack.password_flag) {
        this.inputPassword = '';
        this.passwordError = '';
        this.isOpenPasswordModal = true;
        return;
      }
      const postParams = {
        pack_id: this.currentPack.id,
        count: String(this.count),
      };
      this.$store.dispatch('pack/setCheckPackResult', { postParams });
    },
    closePasswordModal() {
      this.isOpenPasswordModal = false;
      this.inputPassword = '';
      this.passwordError = '';
    },
    async submitPassword() {
      if (!this.inputPassword) {
        this.passwordError = this.t('パスワードを入力してください');
        return;
      }
      const postParams = {
        pack_id: this.currentPack.id,
        password: this.inputPassword,
      };
      await this.$store.dispatch('pack/setSavePackPassword', { postParams });
      const result = this.$store.getters['pack/savePackPassword'];
      if (result && result.status === 'success') {
        this.isOpenPasswordModal = false;
        this.inputPassword = '';
        this.passwordError = '';
        await this.$store.dispatch('pack/setCurrentPack', { packId: this.currentPack.id });
        const checkParams = {
          pack_id: this.currentPack.id,
          count: String(this.count),
        };
        this.$store.dispatch('pack/setCheckPackResult', { postParams: checkParams });
      } else {
        this.passwordError = (result && result.message) || this.t('パスワードが一致しません。');
      }
    },
    changeCurrentPageCount(page) {
      this.page = page;
      this.$store.dispatch('pack/setPackCardList', { packId: this.currentPack.id, pageNumber: page });
    },
    handleDetailCard(card) {
      this.popupCardData = card;
      this.showCardDetail = true;
    },
    buyPack() {
      if (this.currentUser.is_login === '0') {
        this.$store.dispatch('user/setShowLoginPage', true);
        return;
      }

      (async () => {
        await this.$store.dispatch('pack/buyPack');
        const { buyPackResult } = this;
        const isSuceess = buyPackResult.state === 200 && buyPackResult.result === '1';
        if (isSuceess) {
          this.$store.dispatch('pack/clearBuyPackResult');
          this.$router.push('/gacha-animation');
        } else {
          const { count } = buyPackResult.errors;
          window.alert(count);
          this.isOpenConfirm = false;
        }
      })();
    },
    setShopLink(detail) {
      let result = detail;
      Object.keys(shopLink).forEach((key) => {
        const regex = new RegExp(key.replace(/[()]/g, '\\$&'), 'g');
        result = result.replace(regex, `<a href="${shopLink[key]}" target="_blank">${key}</a>`);
      });
      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
.pack-detail{
  width: 100%;
  max-width: 900px;
  min-height: 100vh;
  padding: 0 0 26px 0;
  margin: 0 auto;
  color: $mainColor;
  .pack-banner-full {
    width: 100vw;
    margin-left: calc(-50vw + 50%);
    display: flex;
    justify-content: center;
    img {
      width: 25%;
      height: auto;
      display: block;
    }
  }
  .lineup-frame-title {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 15px auto;
    width: 80%;
    max-width: 400px;
    img {
      width: 100%;
      height: auto;
    }
    span {
      position: absolute;
      color: white;
      font-size: 22px;
      font-weight: bold;
      text-shadow: 0 2px 4px rgba(0, 0, 0, 0.3);
      letter-spacing: 6px;
      white-space: nowrap;
      max-width: 90%;
      overflow: hidden;
    }
  }
  .card_list_area {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-bottom: 90px;
    margin-top:20px;
    .card_list {
      flex-grow: 1;
      width: auto;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 150px;
        margin: 2px;
      }
    }
    .list_comment {
      margin: 20px 0;
      text-align: center;
    }
  }
  .detail_area {
    position: fixed;
    bottom: 100px;
    left: 50%;
    transform: translateX(-50%);
    width: 100%;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
    z-index: 10;
    border-radius: 8px;
    &::before {
      content: "";
      position: absolute;
      width: 100%;
      height: 100%;
      border-radius: 8px;
      padding: 2px;
      background: linear-gradient(to right,#f4ec4d, #e3a735, #d91e1b);
      -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
      -webkit-mask-composite: xor;
      mask-composite: exclude;
    }
    .detail_left{
      padding-bottom: 10px;
      flex: 1;
      align-items: center;
      display: flex;
      flex-direction: column;
      color: #717071;
      font-weight: bold;
      .count01 {
        .c01 {
          display: flex;
          align-items: center;
          font-size: 30px;
          margin-right: 20px;
          .image{
            margin-top: 8px;
            width: 55px;
            img{
              width:60px;
            }
          }
        }
      }
      .count02 {
        margin-bottom: 5px;
        font-size: 25px;
      }
      .gacha-bar{
        width: 60% !important;
      }
      .detail_block {
        margin-top: 40px;
      }
      .container{
        width: 80%;
      }
    }
    .detail_right {
      flex: 1.2;
      align-items: center;
      display: flex;
      flex-direction: column;
      .count_base_area_block{
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        .count_base_area{
          .count_area {
            display: flex;
            padding-bottom: 10px;
            border-bottom: solid 1px $white;
            span {
              font-size: 24px;
            }
          }
        }
      }
      .gray_area {
        padding: 20px;
        .count_area {
          display: flex;
          align-items: center;
          gap: 10px;
          padding-bottom: 10px;
          .select_box {
            min-width: 150px;
            padding: 3px;
          }
          .purchase-btn {
            padding: 14px 20px;
            min-width: 140px;
            white-space: nowrap;
          }
        }
      }
      .point_area {
        padding: 10px 0;
        .point {
          font-size: 24px;
        }
        span {
          font-size: 20px;
        }
      }
      .end_date {
        // text-align: center;
        // margin-top: 20px;
        // color: red;
        font-weight: bold;
        .end_date_txt {
          background-color: #e60012;
          color: $white;
          padding: 3px 10px;
        }
        .end_date_day {
          white-space: nowrap;
          background-color: $white;
          color: #b81a24;
          padding: 3px 10px;
        }
      }
    }
  }
}//_______________________________________________\
.popup_card_area {
  position: fixed;
  background-color: rgba(0, 0, 0, 0.4);
  width: 100vw;
  height: 100vh;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9000;
  .popup_card {
    background-color: #fff;
    border-radius: 10px;
    padding: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 350px;
    width: 85%;
    .popup-card-image {
      width: 100%;
      max-width: 250px;
      border-radius: 6px;
    }
    .popup-card-name {
      margin-top: 15px;
      font-size: 16px;
      font-weight: bold;
      text-align: center;
      color: #333;
    }
    .popup-card-rarity {
      margin-top: 5px;
      font-size: 14px;
      text-align: center;
      color: #555;
    }
    .popup-card-model {
      margin-top: 3px;
      font-size: 14px;
      text-align: center;
      color: #555;
    }
    .popup-close-btn {
      margin-top: 20px;
      padding: 8px 40px;
      background: #e0e0e0;
      border: none;
      border-radius: 5px;
      font-size: 14px;
      cursor: pointer;
      color: #333;
      &:hover {
        background: #ccc;
      }
    }
  }
}
.pack-confirm {
  border-radius: 10px;
  max-width: 600px;
  min-width: 400px;
  padding: 30px;
  position: relative;
  .block {
    padding: 30px 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin: 10px 20px;
    font-weight: bold;
    color: $gray2;
    text-align: center;
    div {
      text-align: center;
    }
  }
  .close_button {
    position: absolute;
    right: 7px;
    top: 15px;
  }
  @media screen and (max-width: $mobileWidth) {
    max-width: 90vw;
    min-width: 320px;
    padding: 40px 20px;
    min-height: 400px;
    .block {
      padding: 20px 10px;
    }
  }
}
.password-modal {
  box-shadow: 10px 10px 10px 5px rgba(0, 0, 0, 0.6);
  width: auto;
  padding: 30px 30px;
  color: $mainColor;
  font-size: 20px;
  .send-button{
    padding: 10px;
    width: 100%;
    font-size: 16px;
  }
  .modal-button-area {
    margin-top: 20px;
  }
}
.overlay_conf {
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999999;
  .modal-button-area {
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
    gap: 30px;
    margin-top: 40px;
    .purchase-btn {
      width: 48%;
    }
    @media screen and (max-width: $mobileWidth) {
      flex-direction: column;
      margin: 40px 0;
      align-items: center;
      gap: 25px;
      .purchase-btn {
        width: 100%;
        max-width: 165px;
      }
    }
  }
}
@media screen and (max-width: $tabletWidth) {
  .pack-detail {
    .pack-banner-full img {
      width: 50% !important;
    }
    .lineup-frame-title {
      span {
        font-size: 18px;
        letter-spacing: 4px;
      }
    }
    .card_list_area {
      padding-bottom: 0px;
      .card_list {
        display: flex;
        margin-bottom: 20px;
        img {
          width: auto!important;
          height: 90px;
          margin: 2px;
        }
      }
    }
    .detail_area{
      bottom: 68px;
      .detail_left{
        .count01 {
          .c01{
            font-size:24px;
          }
        }
        .count02{
          font-size: 20px;
        }
        .point_base_area {
          flex-direction: column;
          margin-top: 0;
          .point_area {
            width: 100%;
            text-align: center;
          }
          .count_base_area_block {
            width: 100% !important;
            padding: 0;
            .count_base_area {
              flex-direction: column;
              align-items: center;
              .count_area {
                margin: 20px 0;
              }
            }
          }
        }
      }
      .detail_right{
        .count_area {
          .select_box {
            min-width: 90px !important;
          }
          .purchase-btn {
            min-width: 110px !important;
          }
        }
        .countdown {
          font-size: 18px;
          flex-direction: column;
          span.num {
            font-size: 24px;
          }
          .purchase-btn{
            min-width: 80px;
          }
        }
      }
    }
  }
}
@media screen and (max-width: $mobileWidth) {
  .pack-detail {
    .pack-banner-full img {
      width: 100% !important;
    }
    .lineup-frame-title {
      width: 70%;
      span {
        font-size: 14px;
        letter-spacing: 3px;
      }
    }
  }
  .card_list_area {
    .card_list {
      img {
        height: 100px !important;
      }
    }
  }
  .detail_area {
    .detail_left {
      .count01 {
        .c01 {
          margin-right: 0px !important;
          font-size: 15px !important;
          .image{
            width:35px !important;
            img{
              width:35px !important;
            }
          }
        }
      }
      .count02 {
        font-size: 15px !important;
      }
    }
    .detail_right {
      .gray_area {
        padding: 5px !important;
        .count_area {
          display: flex;
          align-items: center;
          gap: 10px;
          .purchase-btn {
            min-width:70px !important;
            padding: 12px 18px !important;
          }
        }
        .end_date {
          font-size: smaller;
        }
      }
    }
  }
}
</style>
